import * as React from 'react';
export const videoSvg = React.forwardRef(function videoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.5 10.739v1.546a2.22 2.22 0 0 1-2.231 2.215H2.23A2.226 2.226 0 0 1 0 12.285v-8.57A2.22 2.22 0 0 1 2.231 1.5h8.038c1.228 0 2.231.993 2.231 2.215v1.553l1.76-.683c.79-.3 1.74.24 1.74 1.176v4.478c0 .937-.95 1.476-1.74 1.176h-.005l-1.755-.676Zm-11-7.024A.72.72 0 0 1 2.231 3h8.038c.41 0 .731.332.731.715v8.57a.72.72 0 0 1-.731.715H2.23a.726.726 0 0 1-.731-.715v-8.57Zm11 5.417 2 .769v-3.8l-2 .777v2.254Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.471 10.17c-.305.21-.721-.018-.721-.398V6.228c0-.38.416-.608.721-.399l2.57 1.777a.487.487 0 0 1 0 .798l-2.57 1.767Z',
    }),
  );
});
videoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var video = {
  category: 'icon',
  colorable: true,
  name: 'video',
  svg: videoSvg,
};
